/** @jsx jsx */

import React, { Fragment as _, useState, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import setBlock from 'services/apiHelpers/setBlockProps';
import getMediaParent from 'services/apiHelpers/getMediaParent';
import SetMediaType from 'components/Editor/SetMediaType';

import EditorBtn from 'components/UI/EditorBtn';
import setBlockProps from 'services/apiHelpers/setBlockProps';
import getBlocksByType from 'services/apiHelpers/getBlocksByType';
import { findByKeyVal_V2 } from 'services/findByKeyVal';
import imageUploadError from 'assets/imageUploadError_hotSpot.svg';
// updated UI
import { H1 as H1_v2, H2 as H2_v2 } from '../EditorUtilities/UI/Headings';
import CheckBox_v2 from '../EditorUtilities/UI/CheckBox';
import NumberPicker_v2 from '../EditorUtilities/UI/NumberPicker';
import ColorPicker_v2 from '../EditorUtilities/UI/ColorPicker';
import getStore from 'services/getStore';
import { ImageLibraryContext } from '../EditImage/EditImage';
import ImageLibrary from '../EditImage/ImageLibrary';
import { AudioUploader } from './AudioUploader';
import InputText from 'components/UI/InputText';

const { lPink, lGrey0, lGrey1 } = colors;

const store = getStore();
const URL_PREFIX = window['chameleon'].CHAMELEON_URL;

const Input = ({ defaultValue, update }) => {
  return (
    <input
      type="text"
      defaultValue={defaultValue}
      css={css`
        width: 100%;
        margin: 0 0 10px 0;
        padding: 10px;
        border: 1px solid ${lGrey1};
        outline: none;
        resize: none;
        font-family: 'Poppins';
        font-size: 12px;
      `}
      onKeyUp={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          update(e.currentTarget.value);
        }
      }}
      onBlur={e => {
        e.preventDefault();
        update(e.currentTarget.value);
      }}
    />
  );
};

export function isMP3(fileName) {
  if (!fileName) {
    return false;
  }

  let isMP3;
  const ext = fileName.split(/\./g);

  isMP3 = ['mp3', 'MP3'].includes(ext[ext.length - 1]);

  return isMP3;
}

const EditAudio = ({ block }) => {
  const { props } = block || {};

  const {
    // imgSrc, // to be updated below
    audioSrc,
    // audioId, // becomes v2
    audioIdV2,
    maxWidth = 960,
    hideControls = false,
    image,
    description = '',
    // imageId, // becomes v2
    imageIdV2,
    autoPlay = false,
    useTranscript = false,
    showTranscriptLabel = 'Show transcript',
    showTranscriptFontSize = 12,
    showTranscriptFontColor = '#000',
    viewingTranscriptUnlocksInteraction = false,
    maxHeight = false,
  } = props;

  //
  // this needs to/should/will be the img src
  // this is resolved in a preprocess. but for just in case...
  let src = props?.src;

  // 'kill' src if it is an .mp3
  if (src && isMP3(src)) {
    src = null;
  }

  const imgSrc = src || props?.imgSrc;
  // || Audio_default < we do not need a default here in settings

  const mediaParent = getMediaParent(block.id);
  const interactionParent = getBlocksByType('Interaction').find(
    i => findByKeyVal_V2(i.id, 'id', mediaParent.id) as any
  );

  const hasTranscript = !!block?.children?.length;

  const { lockDown } = interactionParent.props;

  const [imageLibrary, setImageLibrary] = useState(false);

  const audioFileInput = useRef<any>(null);

  let audioSrcFileName = audioSrc ? audioSrc.split(/\//g) : [];
  if (audioSrcFileName.length) {
    audioSrcFileName = audioSrcFileName[audioSrcFileName.length - 1];
  }

  return (
    <_>
      <div>
        <SetMediaType block={block} mediaParent={mediaParent} />

        <div
          css={css`
            margin-top: 20px;
          `}
        >
          <AudioUploader
            audioSrc={audioSrc}
            audioId={audioIdV2}
            setBlock={setBlock}
            block={block}
          />

          <div
            css={css`
              margin: 15px 0 0 0;
            `}
          >
            <EditorBtn
              label="Insert image"
              style={{
                width: `${'175px'}`,
                margin: '0 0 15px 0',
                border: `1px solid ${lGrey0}`,
                background: '#fff',
                color: lGrey0,
                fontSize: 11,
                hover: {
                  color: '#fff',
                  background: '#28292b',
                },
              }}
              css={css`
                min-height: 30px;
              `}
              onClick={() => {
                setImageLibrary(!imageLibrary);
              }}
            />

            <div
              css={css({
                margin: '0 0 10px 0',
              })}
            >
              <CheckBox_v2
                label="Respond to screen height"
                on={maxHeight}
                onClick={() => setBlockProps(block, { maxHeight: !maxHeight })}
              />
            </div>

            <div
              css={css({
                margin: '0 0 10px 0',
              })}
            >
              <div
                css={css`
                  font-size: 12px;
                `}
              >
                Give your image a description for screen readers.
              </div>
              <Input
                defaultValue={description}
                update={value => {
                  setBlockProps(block, { description: value });
                }}
              />
            </div>
          </div>

          <CheckBox_v2
            label="Lock down"
            on={lockDown}
            onClick={() =>
              setBlockProps(interactionParent, {
                lockDown: !!lockDown ? 0 : 1,
              })
            }
            style={{ margin: '0 0 10px 0' }}
          />

          <CheckBox_v2
            label="Autoplay"
            on={autoPlay}
            onClick={() =>
              setBlockProps(block, {
                autoPlay: !autoPlay,
              })
            }
            style={{ margin: '0 0 10px 0' }}
          />

          {hasTranscript && (
            <CheckBox_v2
              label="Include transcript"
              on={useTranscript}
              onClick={() =>
                setBlockProps(block, {
                  useTranscript: !useTranscript,
                })
              }
            />
          )}

          {useTranscript && (
            <_>
              <div style={{ margin: '0px 0 0 0' }}>
                <div
                  css={css`
                    display: flex;
                    align-items: center;
                  `}
                >
                  <H2_v2 style={{ marginRight: 15 }}>Label</H2_v2>
                  <InputText
                    defaultValue={showTranscriptLabel}
                    onUpdate={value => {
                      setBlockProps(block, { showTranscriptLabel: value });
                    }}
                    onEnter={value => console.log(value)}
                  />
                </div>

                <NumberPicker_v2
                  label="Font Size"
                  value={showTranscriptFontSize}
                  increment={1}
                  limit={100}
                  onChange={value => {
                    setBlockProps(block, { showTranscriptFontSize: value });
                  }}
                />
                <div style={{ margin: '10px 0 0 0' }}>
                  <ColorPicker_v2
                    inColor={showTranscriptFontColor}
                    outColor={color =>
                      setBlockProps(block, { showTranscriptFontColor: color })
                    }
                    label="Colour"
                  />
                </div>
              </div>

              <div style={{ margin: '10px 0 0 0' }}>
                <CheckBox_v2
                  label="Viewing transcript unlocks interaction"
                  on={viewingTranscriptUnlocksInteraction}
                  onClick={() =>
                    setBlockProps(block, {
                      viewingTranscriptUnlocksInteraction: !viewingTranscriptUnlocksInteraction,
                    })
                  }
                />
              </div>
            </_>
          )}
        </div>
      </div>

      {imageLibrary && (
        <ImageLibraryContext.Provider
          value={{
            onAddImage(result) {
              const url = (result && result.url) || imageUploadError;

              // we could delete the imgSrc if it already exists before updateing with src...?
              //
              setBlockProps(block, {
                src: url,
                imageIdV2: result.id,
              });
            },
            onClose() {
              setImageLibrary(!imageLibrary);
            },
            currentImageSrc: imgSrc || image,
            currentImageId: imageIdV2,
            cacheSelected: {
              yourLibrary: null,
              chameleonsLibrary: 0,
            },
            cacheFilter: {
              value: '',
            },
          }}
        >
          <ImageLibrary />
        </ImageLibraryContext.Provider>
      )}
    </_>
  );
};

export default EditAudio;
